// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'toggle_collapse_menu';
export const DRAWER_TYPE = 'drawer_type';
export const FIXED_DRAWER = 'fixed_drawer';
export const COLLAPSED_DRAWER = 'collapsible';
export const MINI_DRAWER = 'mini_drawer';
export const THEME_COLOR = 'theme_color';
export const DARK_THEME = 'dark_theme';
export const WINDOW_WIDTH = 'window-width';
export const SWITCH_LANGUAGE = 'switch-language';
export const CHANGE_DIRECTION = 'change-direction';

export const CHANGE_NAVIGATION_STYLE = 'change-navigation-style';
export const HORIZONTAL_NAVIGATION = 'horizontal_navigation';
export const VERTICAL_NAVIGATION = 'vertical_navigation';

export const HORIZONTAL_MENU_POSITION = 'horizontal_menu_position';
export const ABOVE_THE_HEADER = 'above_the_header';
export const INSIDE_THE_HEADER = 'inside_the_header';
export const BELOW_THE_HEADER = 'below_the_header';

export const SHOW_MESSAGE = 'show_message';
export const HIDE_MESSAGE = 'hide_message';

//Dashboard
export const FETCH_EXCHANGE_LIST = 'fetch_exchange_list';
export const FETCH_EXCHANGE_LIST_SUCCESS = 'fetch_exchange_list_success';
export const FETCH_EXCHANGE_LOADER = 'fetch_exchange_loader';
export const SHOW_DASHBOARD_MESSAGE = 'show_dashboard_message';
export const HIDE_DASHBOARD_MESSAGE = 'hide_dashboard_message';
export const FETCH_QUOTE = 'fetch_quote';
export const FETCH_QUOTE_SUCCESS = 'fetch_quote_success';
export const SHOW_QUOTE_LOADER = 'show_quote_loader';
export const FETCH_PATIENTS_LIST_TODAY = 'fetch_patients_list_today'
export const SHOW_PATIENTS_LIST_TODAY_LOADER = 'show_patients_list_today_loader'
export const FETCH_PATIENTS_LIST_TODAY_SUCCESS = 'fetch_patients_list_today_success'

//Profile
export const FETCH_PROFIL = 'fetch_profile'
export const FETCH_PROFILE_SUCCESS = 'fetch_profile_success'
export const SHOW_PROFILE_MESSAGE = 'show_profile_message'
export const ON_UPDATE_PROFILE = 'on_update_profile'
export const UPDATE_PROFILE_SUCCESS = 'on_update_profile_success'
export const SHOW_PROFILE_BUTTON_LOADER = 'show_profile_button_loader'
export const SHOW_PASSWORD_BUTTON_LOADER = 'show_password_button_loader'
export const ON_CHANGE_PASSWORD_PROFILE = 'on_change_password_profile'
export const SHOW_PROFILE_PASSWORD_BUTTON_LOADER = 'show_profile_password_button_loader'
export const UPDATE_PROFILE_PASSWORD_SUCCESS = 'update_profile_password_success'
export const HIDE_PROFILE_MESSAGE = 'hide_profile_message'

//Patients
export const FETCH_PATIENTS = 'fetch_patients';
export const FETCH_PATIENTS_SUCCESS = 'fetch_patients_success';
export const FETCH_STARTED_PATIENTS = 'fetch_started_patients';
export const FETCH_STARTED_PATIENTS_SUCCESS = 'fetch_started_patients_success';
export const FILTER_PATIENTS = 'filter_patients';
export const GET_PATIENTS = 'get_patients';
export const HANDLE_REQUEST_CLOSE = 'handle_request_close';
export const ON_ADD_PATIENT = 'on_add_patient';
export const ON_PATIENT_CLOSE = 'on_patient_close';
export const ON_DELETE_PATIENT = 'on_delete_patient';
export const ON_DELETE_PATIENT_CLOSE = 'on_delete_patient_close';
export const DELETE_PATIENT_SUCCESS = 'delete_patient_success';
export const ON_FILTER_OPTION_SELECT = 'on_filter_option_select';
export const ON_SAVE_PATIENT = 'on_save_patient';
export const HIDE_PATIENTS_LOADER = 'hide_patients_loader';
export const SHOW_PATIENTS_LOADER = 'show_patients_loader';
export const SAVE_PATIENT_SUCCESS = 'save_patient_success';
export const ON_TOGGLE_DRAWER = 'on_toggle_drawer';
export const SHOW_PATIENT_MESSAGE = 'show_patient_message';
export const SHOW_MORE_PATIENTS_LOADER = 'show_more_patients_loader';

//Single Patient
export const FETCH_PATIENT_DOCTORS = 'fetch_patient_doctors';
export const FETCH_PATIENT_DOCTORS_SUCCESS = 'fetch_patient_doctors_success';
export const FETCH_PATIENT_BY_ID = 'fetch_patient_by_id';
export const FETCH_PATIENT_BY_ID_SUCCESS = 'fetch_patient_by_id_success';
export const SHOW_SINGLE_PATIENT_LOADER = 'show_single_patient_loader';
export const SHOW_SINGLE_PATIENT_MESSAGE = 'show_single_patient_message';
export const HIDE_SINGLE_PATIENT_LOADER = 'hide_single_patient_loader';
export const ON_PATIENT_SAVE_IMAGES = 'on_patient_save_image';
export const UPDATE_PATIENT_IMAGES = 'update_patient_images';
export const ON_PATIENT_DELETE_IMAGES = 'on_patient_delete_images';
export const PATIENT_DELETE_IMAGES_SUCCESS = 'patient_delete_images_success';
export const SHOW_SINGLE_PATIENT_IMAGE_LOADER = 'show_single_patient_image_loader';
export const FETCH_PATIENT_HISTORY = 'fetch_patient_history';
export const FETCH_PATIENT_HISTORY_SUCCESS = 'fetch_patient_history_success';
export const ADD_NEW_PAID = 'add_new_paid';
export const ADD_NEW_PAID_SUCCESS = 'add_new_paid_success';
export const SHOW_SINGLE_PATIENT_HISTORY_LOADER = 'show_single_patient_history_loader';
export const ON_UPDATE_PATIENT = 'on_update_patient';
export const ON_UPDATE_PATIENT_SUCCESS = 'on_update_patient_success';
export const ON_DELETE_PAYMENT = 'on_delete_payment';
export const DELETE_PATIENT_HISTORY = 'delete_patient_history';
export const ON_SAVE_NEW_INTERVENTIONS = 'on_save_new_interventions';
export const SHOW_SAVING_INTERVENTIONS_BTN_LOADER = 'show_saving_interventions_btn_loader';
export const SAVE_INTERVENTIONS_SUCCESS = 'save_interventions_success';

//Appointments
export const FETCH_APPOINTMENTS_BETWEEN_DATES = 'fetch_appointments_between_dates';
export const FETCH_APPOINTMENTS_BETWEEN_DATES_SUCCESS = 'fetch_appointments_between_dates_success';
export const FETCH_MORE_PATIENTS = 'fetch_more_patients';
export const FETCH_MORE_PATIENTS_SUCCESS = 'fetch_more_appointments_success';
export const ON_CREATE_APPOINTMENTS = 'on_create_appointments';
export const SHOW_APPOINTMENTS_LOADER = 'show_appointments_loader';
export const SAVE_APPOINTMENTS_SUCCESS = 'save_appointments_success';
export const SHOW_APPOINTMENTS_MESSAGE = 'show_appointments_message';
export const HIDE_APPOINTMENTS_MESSAGE = 'hide_appointments_message';
export const FETCH_APPOINTMENTS_DOCTORS = 'fetch_appointments_doctors';
export const FETCH_APPOINTMENTS_DOCTORS_SUCCESS = 'fetch_appointments_doctors_success';
export const ON_DELETE_APPOINTMENTS = 'on_delete_appointments';
export const DELETE_APPOINTMENTS_SUCCESS = 'delete_appointments_success';

//Auth const
export const SIGNIN_USER = 'signin_user';
export const SIGNIN_USER_SUCCESS = 'signin_user_success';
export const SIGNOUT_USER = 'signout_user';
export const SIGNOUT_USER_SUCCESS = 'signout_user_success';
export const INIT_URL = 'init_url';
export const GET_USER = 'get_user';
export const FETCH_USER = 'fetch_user';
export const UPDATE_PROFILE_AUTH_USER = 'update_profile_auth_user';

//Company
export const FETCH_COMPANY = 'fetch_company';
export const FETCH_COMPANY_SUCCESS = 'fetch_company_success';
export const SHOW_COMPANY_MESSAGE = 'show_company_message';
export const SHOW_COMPANY_LOADER = 'show_company_loader';
export const ON_UPDATE_COMPANY = 'on_update_company';
export const SHOW_BTN_UPDATE_COMPANY = 'show_btn_update_company';
export const UPDATE_COMPANY_SUCCESS = 'update_company_success';
export const ON_ADD_USER = 'on_add_user';
export const ON_USER_CLOSE = 'on_user_close';
export const HIDE_COMPANY_MESSAGE = 'hide_company_message';
export const SHOW_COMPANY_USERS_LOADER = 'show_company_users_loader';
export const FETCH_COMPANY_USERS = 'fetch_company_users';
export const FETCH_COMPANY_USERS_SUCCESS = 'fetch_company_users_success';
export const ON_UPDATE_COMPANY_USER = 'on_update_company_user';
export const ON_UPDATE_COMPANY_USER_SUCCESS = 'on_update_company_user_success';
export const ON_CREATE_COMPANY_USER = 'on_create_company_user';
export const ON_CREATE_COMPANY_USER_SUCCESS = 'on_create_company_user_success';

//New Interventions
export const SHOW_NEW_INTERVENTIONS_LOADER = 'show_new_interventions_loader';
export const FETCH_NEW_INTERVENTIONS_DOCTORS = 'fetch_new_interventions_doctors';
export const FETCH_NEW_INTERVENTIONS_DOCTORS_SUCCESS = 'fetch_new_interventions_doctors_success';
export const ON_SAVE_INTERVENTIONS = 'on_save_interventions';
export const SHOW_NEW_INTERVENTIONS_SAVE_LOADER = 'show_new_interventions_save_loader';
export const SHOW_NEW_INTERVENTIONS_MESSAGE = 'show_new_interventions_message';
export const HIDE_NEW_INTERVENTIONS_MESSAGE = 'hide_new_interventions_message';

//General const
export const ON_SHOW_LOADER = 'on_show_loader';

//New Interventions
export const FETCH_PAYMENTS = 'fetch_payments';
export const FETCH_PAYMENTS_SUCCESS = 'fetch_payments_success';
export const SHOW_PAYMENTS_LOADER = 'show_payments_loader';
export const SHOW_PAYMENTS_MESSAGE = 'show_payments_message';
export const HIDE_PAYMENTS_MESSAGE = 'hide_payments_message';

//Expenses
export const FETCH_EXPENSES = 'fetch_expenses';
export const FETCH_EXPENSES_SUCCESS = 'fetch_expenses_success';
export const SHOW_EXPENSES_LOADER = 'show_expenses_loader';
export const SHOW_EXPENSES_MESSAGE = 'show_expenses_message';
export const HIDE_EXPENSES_MESSAGE = 'hide_expenses_message';
export const ON_SAVE_EXPENSES = 'on_save_expenses';
export const ON_EDIT_EXPENSES = 'on_edit_expenses';
export const SAVE_EXPENSES_SUCCESS = 'save_expenses_success';
export const CHANGE_STATE_NEW_EXPENSES = 'change_state_new_expenses';
export const DELETE_EXPENSES = 'delete_expenses';


// Chat Module const

// export const FETCH_ALL_CHAT_USER = 'fetch_all_chat_user';
// export const FETCH_ALL_CHAT_USER_CONVERSATION = 'fetch_all_chat_user_conversation';
// export const FETCH_ALL_CHAT_USER_SUCCESS = 'fetch_all_chat_user_success';
// export const FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS = 'fetch_all_chat_user_conversation_success';
// export const FILTER_USERS = 'filter_users';
// export const ON_SELECT_USER = 'on_select_user';
// export const ON_HIDE_LOADER = 'on_hide_loader';
// export const USER_INFO_STATE = 'user_info_state';
// export const SUBMIT_COMMENT = 'submit_comment';
// export const UPDATE_MESSAGE_VALUE = 'update_message_value';
// export const UPDATE_SEARCH_CHAT_USER = 'update_search_chat_user';

//// Mail Module const


// export const ADD_LABEL = 'ADD_LABEL';
// export const GET_ALL_MAIL = 'get_all_mail';
// export const FETCH_ALL_MAIL = 'fetch_all_mail';
// export const FETCH_ALL_MAIL_SUCCESS = 'fetch_all_mail_success';
// export const GET_IMPORTANT_MAIL = 'get_important_mail';
// export const GET_NAV_FILTERS = 'get_nav_filters';
// export const GET_NAV_LABELS = 'get_nav_labels';
// export const GET_NAV_FOLDER = 'get_nav_folder';
// export const GET_READ_MAIL = 'get_read_mail';
// export const GET_STARRED_MAIL = 'get_starred_mail';
// export const GET_UNIMPORTANT_MAIL = 'get_unimportant_mail';
// export const GET_UNREAD_MAIL = 'get_unread_mail';
// export const GET_UNSELECTED_ALL_MAIL = 'get_unselected_all_mail';
// export const GET_UNSTARRED_MAIL = 'get_unstarred_mail';
// export const ON_ALL_MAIL_SELECT = 'on_all_mail_select';
// export const ON_FOLDER_MENU_ITEM_SELECT = 'on_folder_menu_item_select';
// export const ON_FOLDER_SELECT = 'on_folder_select';
// export const ON_IMPORTANT_SELECT = 'on_important_select';
// export const ON_LABEL_MENU_ITEM_SELECT = 'on_label_menu_item_select';
// export const GET_MARK_AS_START = 'get_mark_as_start';
// export const ON_LABEL_SELECT = 'on_label_select';
// export const ON_MAIL_CHECKED = 'on_mail_checked';
// export const ON_MAIL_SELECT = 'on_mail_select';
// export const ON_MAIL_SEND = 'on_mail_send';
// export const ON_OPTION_MENU_ITEM_SELECT = 'on_option_menu_item_select';
// export const ON_OPTION_MENU_SELECT = 'on_option_menu_select';
// export const ON_START_SELECT = 'on_start_select';
// export const SEARCH_MAIL = 'search_mail';
// export const ON_DELETE_MAIL = 'on_delete_mail';
// export const SET_CURRENT_MAIL_NULL = 'set_current_mail_null';
// export const ON_COMPOSE_MAIL = 'on_compose_mail';

//// TO-DO Module const

// export const ON_SORTEND = 'on_sortend';
// export const FETCH_ALL_TODO = 'fetch_all_todo';
// export const FETCH_ALL_TODO_SUCCESS = 'fetch_all_todo-success';
// export const FETCH_ALL_TODO_CONVERSATION = 'fetch_all_todo_conversation';
// export const FETCH_ALL_TODO_CONVERSATION_SUCCESS = 'fetch_all_todo_conversation_success';
// export const SELECT_ALL_TODO = 'select_all_todo';
// export const GET_ALL_TODO = 'get_all_todo';
// export const GET_UNSELECTED_ALL_TODO = 'get_unselected_all_todo';
// export const GET_STARRED_TODO = 'get_starred_todo';
// export const GET_UNSTARRED_TODO = 'get_unstarred_todo';
// export const GET_IMPORTANT_TODO = 'get_important_todo';
// export const GET_UNIMPORTANT_TODO = 'get_unimportant_todo';
// export const ON_LABEL_UPDATE = 'on_label_update';
// export const ON_TODO_UPDATE = 'on_todo_update';
// export const ON_DELETE_TODO = 'on_delete_todo';
// export const SEARCH_TODO = 'search_todo';
// export const SHOW_TODOS = 'show_todos';
// export const GET_TODO_CONVERSATION = 'get_todo_conversation';
// export const ON_TODO_CHECKED = 'on_todo_checked';
// export const ON_TODO_ADD = 'on_todo_add';
// export const ON_TODO_SELECT = 'on_todo_select';
// export const SET_CURRENT_TODO_NULL = 'set_current_todo_null';
// export const REMOVE_LABEL = 'remove_label';
// export const UPDATE_SEARCH = 'update_search';




// WEBPACK FOOTER //
// ./constants/ActionTypes.js